module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE1IDE1Ij4KICAgIDxwYXRoIGZpbGw9IiM5QjlCOUIiIGQ9Ik03LjUgMEMzLjM2NiAwIDAgMy4zNjYgMCA3LjVTMy4zNjYgMTUgNy41IDE1IDE1IDExLjYzNCAxNSA3LjUgMTEuNjM0IDAgNy41IDB6TTExIDcuODE4SDcuODE4VjExaC0uNjM2VjcuODE4SDR2LS42MzZoMy4xODJWNGguNjM2djMuMTgySDExdi42MzZ6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus-circle.svg
// module id = 923
// module chunks = 0